import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

export function OfflineStatusBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div role="status" aria-live="polite" className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-950">
      <div className="mx-auto flex max-w-5xl items-center gap-2">
        <WifiOff className="h-4 w-4 shrink-0" />
        <span>
          Offline build mode is active. Manual resume forms and downloads are available; AI, uploads, payments, sharing, and cloud sync will resume when you reconnect.
        </span>
      </div>
    </div>
  );
}
